import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import { UserProfileProvider } from "./UserProfileContext";
import Layout from "./Layout";
import AppRoutes from "./AppRoutes";

const App: React.FC = () => {
  let routes = AppRoutes();
  let router = createBrowserRouter([
    {
      Component: Layout,
      children: routes,
    },
  ]);

  return (
    <Auth0Provider
      domain={
        process.env.REACT_APP_AUTH0_DOMAIN ||
        "dev-8qhmswak12gyu3ui.us.auth0.com"
      }
      clientId={
        process.env.REACT_APP_AUTH0_UI_CLIENTID ||
        "1E648Ggt3CP3EYVDI5unlDMulArQRTqd"
      }
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: process.env.REACT_APP_AUTH0_API_AUDIENCE || "dfo-dev-api",
        scope: "openid profile email",
      }}
      cacheLocation={
        process.env.NODE_ENV === "development"
          ? ("localstorage" as const)
          : ("memory" as const)
      }
    >
      <UserProfileProvider>
        <RouterProvider router={router} />
      </UserProfileProvider>
    </Auth0Provider>
  );
};

export default App;
